import { SupportService } from '@asteria/backend-utils-services';

export async function report({ accessToken, input }) {
	return SupportService.issue.reportIssues(
		{ input: input },
		{ token: accessToken },
	);
}
